var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanScheduleHappeningWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2546_18526)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2546_18526)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-96.5121 44.99L-71.4919 44.8943C-46.7868 44.9124 3.25348 44.721 38.6355 17.021C74.0176 -10.6789 90.5415 -41.5202 147.263 -62.0208C203.985 -82.5213 239.647 -76.5062 264.352 -76.4881L301.438 -53.3466L226.783 -197.118L205.675 -189.489C184.882 -181.973 142.665 -166.715 100.763 -151.571C58.8615 -136.426 16.6447 -121.168 -25.257 -106.024C-67.1586 -90.8796 -109.375 -75.6214 -130.169 -68.1062L-151.277 -60.4771L-96.5121 44.99Z",
    fill: "#E9E8FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-95.9413 80.701L-71.6422 75.2058C-47.6119 69.8875 0.986286 58.8971 26.2581 24.7994C51.5299 -9.29824 57.4273 -42.3232 105.825 -74.1537C154.222 -105.984 190.885 -107.941 214.916 -113.26L258.612 -99.1671L138.6 -220.358L120.589 -208.513C102.847 -196.844 66.8258 -173.153 31.0733 -149.639C-4.6792 -126.125 -40.7005 -102.435 -76.4531 -78.9206C-112.206 -55.4066 -148.227 -31.7158 -165.969 -20.0473L-183.979 -8.20186L-95.9413 80.701Z",
    fill: "#6B40ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-82.3101 113.553L-60.4951 101.797C-38.8886 90.283 4.7414 66.7709 19.4125 27.2502C34.0836 -12.2704 30.4263 -45.5995 67.9767 -89.099C105.527 -132.598 140.231 -144.245 161.838 -155.759L207.839 -153.845L58.1965 -238.425L44.2225 -222.238C30.4571 -206.291 2.50908 -173.915 -25.2304 -141.781C-52.9698 -109.647 -80.9178 -77.2712 -108.657 -45.137C-136.397 -13.0028 -164.345 19.3731 -178.11 35.3194L-192.084 51.5073L-82.3101 113.553Z",
    fill: "#6B40ED"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2546_18526"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 10C61 4.47715 56.5228 0 51 0H10C4.47715 0 0 4.47715 0 10V50C0 55.5228 4.47715 60 10 60H51C56.5228 60 61 55.5228 61 50V10Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2546_18526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanScheduleHappeningWave);
export default __webpack_public_path__ + "static/media/plan-schedule-happening-wave.8568e1fe718ba23ad3dd0a32a96c35cb.svg";
export { ForwardRef as ReactComponent };